import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import FetchData from './../providers/dataProvider';
import urls from '../constants';

export const useRolePermission = (resource) => {
    const navigate = useNavigate();
    const [menuRights, setmenuRights] = useState(null)
    const menuAccess = FetchData("menupermissions", { applicationCode: urls.APPLICATION_CODE });

    useEffect(() => {
        const rawResponse = menuAccess?.data;
        const topLevelMenus =
            (Array.isArray(rawResponse?.menus) && rawResponse.menus) ||
            (Array.isArray(rawResponse?.data) && rawResponse.data) ||
            (Array.isArray(rawResponse) && rawResponse) ||
            [];

        const flatMenus = topLevelMenus.flatMap((menu) => [
            menu,
            ...(Array.isArray(menu?.subMenus) ? menu.subMenus : []),
        ]);

        const matched = flatMenus.find((item) => item?.menuName === resource);
        if (matched) setmenuRights(matched);
    }, [menuAccess, resource])

    useEffect(() => {
        if (
            menuRights &&
            menuRights?.canAdd === false &&
            menuRights?.canDelete === false &&
            menuRights?.canView === false &&
            menuRights?.canEdit === false
        ) {
            navigate("/dashboard")
        }
    }, [menuRights])

    return {
        menuRights
    }
}